/**
 * General Styles For The Layout
 * @type {function(*): {}}
 */
import { fade, makeStyles } from '@material-ui/core'
import { ArabicFont, EnglishFont } from '../../utils/Fonts'

export const useStyles = makeStyles((theme) => ({
  '@global': {
    html: { height: '100%' },
    body: {
      height: '100%',
      backgroundColor: '#EBF6FD',
      textAlign: 'left'
    },
    '#root': {
      height: '100%',
      whiteSpace: 'pre-line'
    },
    'a': {
      textDecoration: 'none',
      transition: 'all 0.3s ease-in-out',
      color: theme.palette.primary.light,
      '&:hover, &:focus': {
        color: theme.palette.primary.light
      }
    },
    'button': {
      fontFamily: theme.direction === 'ltr' ? EnglishFont : ArabicFont,
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      outline: 'none !important'
    },
    'img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'inline-block'
    },
    'h1, h2, h3, h4, h5, h6': {
      fontFamily: theme.direction === 'ltr' ? EnglishFont : ArabicFont,
      fontWeight: 'bold'
    },
    '.MuiButton-root': {
      textTransform: 'none'
    },
    '.MuiBackdrop-root': {
      backgroundColor: fade(theme.palette.common.black, 0.75),
      backdropFilter: 'blur(2px)'
    },
    '.MuiPickersDay-daySelected': {
      color: theme.palette.common.white
    },
    '.MuiButton-containedPrimary': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.light,
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.hover
      }
    },
    '.MuiInputBase-root.Mui-disabled': {
      backgroundColor: theme.palette.secondary.main
    },
    // '.MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline,.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //   borderColor: theme.palette.primary.hover
    // },
    '.back-white': {
      backgroundColor: theme.palette.common.white
    },
    '[class*="MUIDataTableToolbar-filterCloseIcon"]': {
      left: 'auto !important',
      right: '4px !important'
    },
    '.MuiTableCell-head': {
      whiteSpace: 'pre'
      // minWidth: 140,
      // maxWidth: 160
    },
    '.MuiTableCell-paddingCheckbox': {
      minWidth: 0,
      width: 0,
      transform: theme.direction === 'ltr' ? 'scaleX(1)' : 'scaleX(-1)'
    },
    '.toasts-container': {
      width: 400,
      marginTop: theme.spacing(6),
      right: 0
    },
    '.notification-close-button': {
      position: 'absolute',
      right: theme.spacing(2)
    },
    '.notification-progress-wrapper': {
      visibility: 'hidden'
    },
    '.notification-wrapper': {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      boxShadow: 'none',
      overflow: 'visible'
    },
    '.notification-component': {
      paddingRight: theme.spacing(4)
    },
    '.Toastify__toast': {
      direction: 'ltr',
      marginBottom: theme.spacing(0)
    },
    '.MuiPickersClockNumber-clockNumberSelected': {
      color: theme.palette.common.white
    },
    '.cke_reset_all, .cke_reset_all *, .cke_reset_all a, .cke_reset_all textarea': {
      fontFamily: theme.direction === 'ltr' ? EnglishFont + '!important' : ArabicFont + '!important'
    },
    '.cke_dialog_footer a.cke_dialog_ui_button_ok': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.hover,
        borderColor: theme.palette.primary.hover
      }
    }
  },
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&>div:first-child': {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column'
    }
  },
  content: {
    flex: '1 1 auto'
  }
}))
